export const BASE_ROUTE = '';
export const ADMIN_ROUTE = BASE_ROUTE+'/admin';
export const LOGIN_ROUTE = BASE_ROUTE+'/login';
export const PROTECTED_ROUTE = BASE_ROUTE+'/protect';
export const REGISTRATION_ROUTE = BASE_ROUTE+'/registration';
export const SHOP_ROUTE = BASE_ROUTE+'/';
export const CART_ROUTE = BASE_ROUTE+'/cart';
export const DEVICE_ROUTE = BASE_ROUTE+'/device';

export const HELP_ROUTE = BASE_ROUTE+'/help';
export const HELP_CAT_ROUTE = BASE_ROUTE+'/help/category'; 
export const HELP_FAQ_ROUTE = BASE_ROUTE+'/help/faq';

export const HELP_TECH_ADMIN_ROUTE = BASE_ROUTE+'/help/tech/get-me-admin';

export const ABOUT_ROUTE = BASE_ROUTE+'/about';
export const ABOUT_CARD1_ROUTE = BASE_ROUTE+'/about/whoweare';
export const ABOUT_CARD2_ROUTE = BASE_ROUTE+'/about/brands';
export const ABOUT_CARD3_ROUTE = BASE_ROUTE+'/about/experience';

export const ACCOUNT_ROUTE = BASE_ROUTE+'/account';

export const ACCOUNT_INFO_ROUTE = BASE_ROUTE+'/account/info';
export const ACCOUNT_DELIVERY_ROUTE = BASE_ROUTE+'/account/delivery';
export const ACCOUNT_PAYMENT_ROUTE = BASE_ROUTE+'/account/payment';
export const ACCOUNT_ORDERS_ROUTE = BASE_ROUTE+'/account/orders';

export const PROFILE_ROUTE = BASE_ROUTE+'/profile';

export const PROFILE_INFO_ROUTE = BASE_ROUTE+'/profile/info';
export const PROFILE_ORDERS_ROUTE = BASE_ROUTE+'/profile/orders';
export const PROFILE_ADDRESS_ROUTE = BASE_ROUTE+'/profile/address';
export const PROFILE_WISHLIST_ROUTE = BASE_ROUTE+'/profile/wishlist';

export const ADMIN_USER_ROUTE = BASE_ROUTE+'/admin/admin-users';
export const ADMIN_ORDERS_ROUTE = BASE_ROUTE+'/admin/admin-orders';
export const ADMIN_DEVICES_ROUTE = BASE_ROUTE+'/admin/admin-devices';
export const ADMIN_TYPES_ROUTE = BASE_ROUTE+'/admin/admin-types';
export const ADMIN_BRANDS_ROUTE = BASE_ROUTE+'/admin/admin-brands';
export const ADMIN_PAGES_ROUTE = BASE_ROUTE+'/admin/page';
export const ADMIN_APP_ROUTE = BASE_ROUTE+'/admin/page/app';
export const ADMIN_HELP_ROUTE = BASE_ROUTE+'/admin/page/help';

export const ADMIN_HELP_FAQ_ROUTE = BASE_ROUTE+'/admin/page/help-faq';
export const ADMIN_HELP_CAT_ROUTE = BASE_ROUTE+'/admin/page/help-cat';

export const ADMIN_ABOUT_ROUTE = BASE_ROUTE+'/admin/page/about';

export const ABOUT_BUTTONS_ROUTE = BASE_ROUTE+'/admin/page/about/btns';
export const ABOUT_BLOCKS_ROUTE = BASE_ROUTE+'/admin/page/about/blocks';
export const ABOUT_LEFT_CARD_ROUTE = BASE_ROUTE+'/admin/page/about/l-card';
export const ABOUT_MIDDLE_CARD_ROUTE = BASE_ROUTE+'/admin/page/about/m-card';
export const ABOUT_RIGHT_CARD_ROUTE = BASE_ROUTE+'/admin/page/about/r-card';

export const SAMPLE_ROUTE = BASE_ROUTE+'/sample';
export const CHECKOUT_ROUTE = BASE_ROUTE+'/checkout';
export const ORDER_COMPLETE_ROUTE = BASE_ROUTE+'/order/complete';
export const ERROR_ROUTE = BASE_ROUTE+'*';
export const NAVBAR_HEIGHT = 60;
export const RANDOM_DEVICES_COUNT = 6;